import "../../style/base.css";
import "../../skeleton-title/index.css";
import "../../skeleton-avatar/index.css";
import "../../skeleton-paragraph/index.css";
import "../index.css";
